export abstract class DataRenderer {
  static readonly MAX_BAR_WIDTH = 12;

  abstract switchHighlight(index: number, highlight: boolean): void;
}
